const formOperate ="/flow/form/operate";
const formSelectList ="/flow/form/selectList";


export default {
    formOperate,formSelectList
  }